import { IsBoolean, ValidateIf } from 'class-validator';

export class NotificationTypeDto {
  /** Backstage / in-app channel. */
  @ValidateIf((_, value) => value !== undefined)
  @IsBoolean()
  push?: boolean;

  /** Email channel. */
  @ValidateIf((_, value) => value !== undefined)
  @IsBoolean()
  email?: boolean;
}
